var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProcessing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57,
    height: 74,
    viewBox: "0 0 57 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "6camt2fnla",
    d: "M0 0.686L56.933 0.686 56.933 72.291 0 72.291z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .023)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "41y0s4s4zb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6camt2fnla"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BF00",
    d: "M46.477 48.6C34.311 67.202 16.37 76.86 6.43 70.17c-9.952-6.68-8.154-27.19 4.024-45.792C22.631 5.783 40.563-3.882 50.504 2.805c9.951 6.684 8.154 27.188-4.027 45.795",
    mask: "url(#41y0s4s4zb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A171B",
    d: "M26.205 46.615c0 1.847-1.497 3.347-3.344 3.347-1.844 0-3.345-1.5-3.345-3.347 0-1.848 1.5-3.346 3.345-3.346 1.847 0 3.344 1.498 3.344 3.346"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M24.4 30.388c-.617 0-1.12-.502-1.12-1.12 0-.617.503-1.12 1.12-1.12h6.94c.617 0 1.12.503 1.12 1.12 0 .618-.503 1.12-1.12 1.12H24.4zm0 4.768c-.617 0-1.12-.503-1.12-1.12 0-.619.503-1.121 1.12-1.121h6.94c.617 0 1.12.502 1.12 1.12 0 .618-.503 1.12-1.12 1.12H24.4zm0 4.766c-.617 0-1.12-.503-1.12-1.12 0-.618.503-1.12 1.12-1.12h6.94c.617 0 1.12.502 1.12 1.12 0 .617-.503 1.12-1.12 1.12H24.4zm-2.468-19.063c-.3.024-1.279.198-1.279 1.418l.003 1.094.068.025h13.012c1.898 0 3.442 1.544 3.442 3.442v20.504c0 .258-.085.5-.244.701l-1.526 1.907h2.055c1.227 0 2.226-1 2.226-2.228V22.855c.006-.108.044-1.1-.45-1.628-.09-.093-.354-.369-1.073-.369H21.935l-.003.001zm9.29 30.736l2.504-3.133H31.22v3.133zm-14.02-25.96c-.665 0-1.203.54-1.203 1.203v24.14c0 .663.538 1.202 1.203 1.202h11.777v-4.838c0-.616.504-1.119 1.122-1.119h4.837V26.838c0-.663-.539-1.202-1.202-1.202H17.202zm0 28.786c-1.9 0-3.446-1.544-3.446-3.443v-24.14c0-1.898 1.546-3.442 3.446-3.442h1.186l-.004-1.119c0-2.582 2.091-3.62 3.497-3.687h16.285c1.422 0 2.275.598 2.74 1.1 1.164 1.253 1.065 3.05 1.05 3.25l.003 1.387v23.395c0 2.48-2.016 4.497-4.496 4.497h-3.685c-.031 0-.06-.004-.09-.008l-.04-.005-.065.026-1.415 1.769c-.215.267-.535.42-.875.42H17.202z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcessing);
export default __webpack_public_path__ + "static/media/icon_processing.a84bf61ed2c9f6ed94b5f53d7d5abc74.svg";
export { ForwardRef as ReactComponent };